import { Box, Typography } from '@mui/material';
import { Guide } from './Guide';

const Home = () => {
  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '16px',
          padding: '0px 15px 64px',
        }}
      >
        <Typography variant='h5'>WELCOME, LET US HELP YOU!</Typography>
        <Typography
          letterSpacing='3px'
          sx={{ fontSize: '13px', textAlign: 'center' }}
        >
          THIS WEBSITE IS FOR THE DEPARTMENT OF THE AIR FORCE PERSONNEL ON OAHU
        </Typography>
      </Box>
      <Guide />
    </Box>
  );
};

export { Home };
